module.exports = __webpack_public_path__ + "static/assets/4240a79d13ecf2792f825457194c96d9.mp3";